import Colors from '../../layout/theme-next/colors';

// formInputSync key shared by every "Show/Hide Deviation Changes" switch of an LHR step
export const DEVIATION_HIDE_KEY = 'deviation-hide-changes';

// Box props that mark a component a deviation added to an LHR step
export const DEVIATION_ADDED_BOX_PROPS = { bgcolor: Colors.successSoft, p: 1, borderRadius: 4 };
